/* eslint-disable react-hooks/exhaustive-deps */

import React, { useLayoutEffect, useState } from "react";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { Layout, Card, Calendar, Badge, Spin, Tag } from "antd";

import dayjs from "dayjs";

import { getAPI } from "../../utils/common";

import { SMART_PRICE_CALENDAR } from "../../constants/api";

function SmartPriceCalendar() {
  const { Content } = Layout;

  const [loading, setLoading] = useState(false);

  const [calendarData, setCalendarData] = useState([]);

  useLayoutEffect(() => {
    getCalendar();
  }, []);

  const getCalendar = () => {
    setLoading(true);

    getAPI(
      SMART_PRICE_CALENDAR,

      (res) => {
        if (res.status === true) {
          setCalendarData(res.data);
        }

        setLoading(false);
      },

      () => {
        setLoading(false);
      },

      {},
    );
  };

  const getDemandData = (date) => {
    let currentDate = date.format("YYYY-MM-DD");

    return calendarData.find(
      (item) => dayjs(item.date).format("YYYY-MM-DD") === currentDate,
    );
  };
  const dateCellRender = (value) => {
    const data = getDemandData(value);

    if (!data) {
      return null;
    }

    let color = "green";

    if (data.level === "High Demand") {
      color = "red";
    } else if (data.level === "Medium Demand") {
      color = "orange";
    }

    return (
      <div>
        <Badge color={color} text={<Tag color={color}>{data.level}</Tag>} />
        <br />
        Score : <b>{data.score}</b>
      </div>
    );
  };

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card title="Smart Pricing Demand Calendar" bordered={false}>
          <Spin spinning={loading}>
            <Calendar cellRender={dateCellRender} />
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default SmartPriceCalendar;
